import { ACTION_FREQUENCY_TYPE, createFrequency, createLinqsetEdge, createLinqsetNode, EDGE_TYPE, Emissions, EMISSIONS_RATE, FREQUENCY_TYPE, getEdgeType, isModelNode, Linqset, LinqsetEdge, LinqsetNode, NODE_SUPERTYPE, NODE_TYPE, TUTORIAL_MODEL_KEY } from "../../common/linqset-model"
import { CARBON_SCOPE, EMISSION_FACTOR_TYPE } from "../../common/organisation"
import { v4 } from "uuid"

export const SUPPLY_CHAIN_INDEX = 10
export const END_INDEX = 17
export const LAST_SUPPLY_CHAIN_STEP = 5
export const LAST_ROLE_STEP = 14

const supplyChainNodeNames = [
    "Receive job brief",
    "Job brief",
    "Write job ad",
    "Draft job ad",
    "Approve ad",
    "Approved job ad",

    "Post to internal board",
    "Internal job ad",
    "Post to job website",
    "Website job ad",

    "Job advertised",

    "Recruitment admin",
    "Recruitment lead",

    "MS Outlook",
    "MS Word",
    "Intranet",
    "Job website"
]


const createNewLinqsetEdge = (from:LinqsetNode, to:LinqsetNode, linqset:Linqset) => {
    const edgeData = {type:getEdgeType(from, to), modelKey: linqset.modelKey, sourceKey: from._key, targetKey:to._key, sourceVisualisationKey:isModelNode(from.superType)?from._key:v4(), targetVisualisationKey:isModelNode(to.superType)?to._key:v4()} as LinqsetEdge
    return createLinqsetEdge(v4(), linqset.organisationKey, linqset.workspaceKey, edgeData)    
}

const createUsedByEdge = (system:LinqsetNode, action:LinqsetNode, linqset:Linqset) => {
    const perform = linqset.edges.find(e => e.type === EDGE_TYPE.PERFORM && e.targetKey === action._key)
    if (perform) {
        const edgeData = {type:EDGE_TYPE.USEBY, modelKey: linqset.modelKey, sourceKey: system._key, targetKey:perform.sourceKey, sourceVisualisationKey:v4(), targetVisualisationKey:perform.sourceVisualisationKey} as LinqsetEdge
        return createLinqsetEdge(v4(), linqset.organisationKey, linqset.workspaceKey, edgeData)    
    }
    return undefined
}

export const createOnboardingLinqset = (linqset:Linqset, includeEdges:boolean) => {
    let previous:LinqsetNode

    linqset.nodes = []
    linqset.edges = []

    for (let i=0; i<= SUPPLY_CHAIN_INDEX; i++) {
        const superType = i===SUPPLY_CHAIN_INDEX?NODE_SUPERTYPE.OUTCOMES:((i % 2 === 0)?NODE_SUPERTYPE.ACTION:NODE_SUPERTYPE.INFORMATION)
        const type = i===0?NODE_TYPE.CAPTURE:(i===SUPPLY_CHAIN_INDEX?NODE_TYPE.OUTCOMES:(superType===NODE_SUPERTYPE.ACTION?NODE_TYPE.ACTION:NODE_TYPE.INFORMATION))

        const n = createLinqsetNode(supplyChainNodeNames[i], superType, type, linqset, supplyChainNodeNames[i])
        linqset.nodes.push(n)

        if (includeEdges) {
            if (previous) {
                linqset.edges.push(createNewLinqsetEdge(previous, n, linqset))
            }
            previous = n
            if (i === 7) {
                previous = linqset.nodes[5]
            }else if (i === 10) {
                // outcome node so also add other branch
                linqset.edges.push(createNewLinqsetEdge(linqset.nodes[7], n, linqset))
            }
        }
    }    
    linqset.nodes[0].properties.frequency = createFrequency(linqset.nodes[0].superType, linqset.nodes[0].type)
    linqset.nodes[0].properties.frequency.type = FREQUENCY_TYPE.WORK_DAYS
    // 5 job ads a work day, 1,200 a year, as the walkthrough's summary says
    linqset.nodes[0].properties.frequency.ocurrences = 5
    linqset.nodes[0].properties.frequency.weeksPerYear = 48

    linqset.nodes[2].properties.duration = {days:0, hours:0, minutes:30, seconds:0}
    linqset.nodes[4].properties.duration = {days:0, hours:1, minutes:0, seconds:0}
    linqset.nodes[6].properties.duration = {days:0, hours:0, minutes:15, seconds:0}
    linqset.nodes[8].properties.duration = {days:0, hours:0, minutes:20, seconds:0}
    linqset.nodes[10].properties.actionProcessType = ACTION_FREQUENCY_TYPE.SUM

    linqset.nodes[7].properties.outputValue = 5
    linqset.nodes[9].properties.outputValue = 7


    let index = linqset.nodes.length

    let node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.ROLE, NODE_TYPE.ROLE, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "Recruitment admin drafts the job ad and posts it to the job website and internal job board."
    node.properties.annualCost = 70000
    node.properties.people = 5
    node.properties.frequency = createFrequency(node.superType, node.type)
    node.properties.frequency.type = FREQUENCY_TYPE.WORK_DAYS
    node.properties.frequency.ocurrences = 1
    node.properties.frequency.weeksPerYear = 48
    node.properties.duration = {days:0, hours:8, minutes:0, seconds:0}

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[0], linqset))
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[2], linqset))
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[6], linqset))
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[8], linqset))
    }

    index++
    node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.ROLE, NODE_TYPE.ROLE, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "Manages the recruitment team and approves ads"
    node.properties.annualCost = 100000
    node.properties.people = 1
    node.properties.frequency = createFrequency(node.superType, node.type)
    node.properties.frequency.type = FREQUENCY_TYPE.WORK_DAYS
    node.properties.frequency.ocurrences = 1
    node.properties.frequency.weeksPerYear = 48
    node.properties.duration = {days:0, hours:8, minutes:0, seconds:0}

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[4], linqset))
    }

    index++
    node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.SYSTEM, NODE_TYPE.SYSTEM, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "Outlook used to send/receive emails."
    node.properties.annualCost = 100

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[1], linqset))
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[5], linqset))

        linqset.edges.push(createUsedByEdge(node, linqset.nodes[0], linqset))
        linqset.edges.push(createUsedByEdge(node, linqset.nodes[4], linqset))
    }

    index++

    node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.SYSTEM, NODE_TYPE.SYSTEM, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "MS Word is used for documents."
    node.properties.annualCost = 100

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[3], linqset))
        linqset.edges.push(createUsedByEdge(node, linqset.nodes[2], linqset))
    }

    index++

    node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.SYSTEM, NODE_TYPE.SYSTEM, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "Intranet board where jobs can be advertised internally."
    node.properties.fixedCost = 5000

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[7], linqset))
        linqset.edges.push(createUsedByEdge(node, linqset.nodes[6], linqset))
    }

    index++

    node = createLinqsetNode(supplyChainNodeNames[index], NODE_SUPERTYPE.SYSTEM, NODE_TYPE.SYSTEM, linqset, supplyChainNodeNames[index])
    linqset.nodes.push(node)
    node.description = "Job website where jobs can be advertised externally."
    node.properties.fixedCost = 20000

    if (includeEdges) {
        linqset.edges.push(createNewLinqsetEdge(node, linqset.nodes[9], linqset))
        linqset.edges.push(createUsedByEdge(node, linqset.nodes[8], linqset))
    }    
}

export const addInfrastructureNodes = (organisationLinqset:Linqset, systems:LinqsetNode[]) => {
    const node = createLinqsetNode("Electricity", NODE_SUPERTYPE.INFRASTRUCTURE, NODE_TYPE.INFRASTRUCTURE, organisationLinqset, "Electricity")
    organisationLinqset.nodes.push(node)
    node.description = "Electricity used to run systems"
    node.properties.hourlyCost = 2

    systems.forEach(s => {
        organisationLinqset.edges.push(createNewLinqsetEdge(node, s, organisationLinqset))
    })

    const {organisation} = organisationLinqset
    organisation.emissionFactors = [{
        _key: v4(),
        scope: CARBON_SCOPE.ScopeTwo,
        type:EMISSION_FACTOR_TYPE.POWER,
        name: "Electricity",
        value: 0.554
    } as EmissionFactor]

    node.properties.emissions = [{
        _key:v4(),
        emissionFactorKey: organisation.emissionFactors[0]._key,
        value: 1,
        rate: EMISSIONS_RATE.HOUR
    } as Emissions]
}

export interface EmissionFactor {
    _key:string,
    scope: CARBON_SCOPE,
    type: EMISSION_FACTOR_TYPE,
    name:string,
    description:string,
    value:number,
    density:number,
    energyDensity:number,
    energyFactor:number
}

export const nodeIndicesForRoleSystem = (index:number) => {
    switch (index) {
        case 11:    // recruitment admin
            return [0, 2, 6, 8]
        case 12:    // recruitment lead
            return [4]
        case 13:    // outlook
            return [0, 1, 4, 5]
        case 14:    // word
            return [2, 3]                                    
        case 15:    // intranet 
            return [6, 7]
        case 16:    // job website
            return [8, 9]
        default:
            return []
    }
}

